<template>
    <div class="inline-block">
        <button
            class="btn btn-md is-ghost is-danger"
            @click="$modal.show('delete-land-owner')"
        >
            Radera
        </button>
        <adaptive-form-modal
            name="delete-land-owner"
            primary-button-text="Radera"
            primary-button-class="is-danger"
            title="Radera ägare"
            :redirect-to="route('admin.delivery-projects.land-properties.show', [project.id, landOwner.land_property_id])"
            method="delete"
            :action="route('api.delivery-projects.land-owners.destroy', [landOwner.id])"
        >
            <p>Vill du verkligen radera ägaren?</p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            project: {
                type: Object,
                required: true,
            },
            landOwner: {
                type: Object,
                required: true,
            },
        },
    };
</script>
